const Notifications = {
  toast: null,
  errorToast: null,
  alert: null
};

Notifications.toast = (message) => {
  if (Notifications.toast) {
    Notifications.toast(message);
  }
};

Notifications.setToaster = (toast) => {
  Notifications.toast = toast;
};

Notifications.errorToast = (message, options) => {
  if (Notifications.errorToast) {
    Notifications.errorToast(message, options);
  }
};

Notifications.setErrorToaster = (toast) => {
  Notifications.errorToast = toast;
};

Notifications.setUpdateToaster = (toast) => {
  Notifications.updateToast = toast;
};

Notifications.alert = null;
Notifications.setAlert = (alert) => {
  Notifications.alert = alert;
};

Notifications.alertError = (message, details) => {
  Notifications.alert(`${message} <div class='error-code'>${details}</div>`);
};


Notifications.confirm = null;
Notifications.setConfirm = (confirm) => {
  Notifications.confirm = confirm;
};

Notifications.choose = null;
Notifications.setChoose = (choose) => {
  Notifications.choose = choose;
};

export default Notifications;
